(function () {
  var CAROUSEL_STYLES = {
    display: 'flex',
    'flex-wrap': 'nowrap',
    'overflow-x': 'auto',
    position: 'static',
    width: '100%',
    'max-width': '100%',
    'margin-left': '0',
    'margin-right': '0',
    transform: 'none',
    'box-sizing': 'border-box',
    'touch-action': 'pan-x pan-y'
  };

  // Writing inline styles onto the scroller while a finger is dragging it
  // cancels the native scroll gesture on iOS Safari (felt as the carousel
  // "sticking"), so only touch a property when it actually drifted.
  function enforceStyles(wrapper) {
    for (var prop in CAROUSEL_STYLES) {
      if (
        wrapper.style.getPropertyValue(prop) !== CAROUSEL_STYLES[prop] ||
        wrapper.style.getPropertyPriority(prop) !== 'important'
      ) {
        wrapper.style.setProperty(prop, CAROUSEL_STYLES[prop], 'important');
      }
    }
  }

  function swapImage(img) {
    var realSrc = img.getAttribute('data-instafeed-src');
    if (realSrc && img.src !== realSrc) {
      img.src = realSrc;
    }
  }

  function loadImages(wrapper) {
    // The app lazy-loads images via its own visibility detection, which
    // relies on the default grid layout's geometry. Our full-bleed
    // horizontal layout confuses that detection, so images past the first
    // few never swap from the placeholder to the real photo. Load them
    // ourselves instead of relying on the app's (now-broken) lazy load --
    // but only as each one nears the viewport, not all at once: forcing
    // every image to decode simultaneously overwhelms mobile Safari's
    // image decoder, showing a blank/white flash on screen.
    //
    // The observer is stored ON the wrapper itself (not a module-level
    // variable) so that if the app ever swaps in a new wrapper element,
    // we create a fresh observer bound to the new one instead of reusing
    // one still rooted on a detached, no-longer-updating old element --
    // that mismatch was silently freezing image loads intermittently.
    if (!wrapper.__instafeedImageObserver) {
      wrapper.__instafeedImageObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              swapImage(entry.target);
              wrapper.__instafeedImageObserver.unobserve(entry.target);
            }
          });
        },
        { root: wrapper, rootMargin: '0px 600px', threshold: 0 }
      );
    }
    var imageObserver = wrapper.__instafeedImageObserver;
    var images = wrapper.querySelectorAll('img.instafeed-lazy-image[data-instafeed-src]:not([data-observed])');
    images.forEach(function (img) {
      img.setAttribute('data-observed', 'true');
      imageObserver.observe(img);
    });

    // Belt-and-suspenders fallback: even if the observer above never fires
    // for some reason, directly force-load anything already sitting in the
    // wrapper's visible scroll range right now. Skip once nothing is left
    // on the placeholder -- otherwise this reflow-triggering rect check
    // would run forever, every 800ms, for as long as the page stays open.
    var stillPlaceholder = wrapper.querySelectorAll('img.instafeed-lazy-image[src*="placeholder.png"]');
    if (stillPlaceholder.length) {
      var wrapperRect = wrapper.getBoundingClientRect();
      stillPlaceholder.forEach(function (img) {
        var r = img.getBoundingClientRect();
        if (r.right >= wrapperRect.left - 600 && r.left <= wrapperRect.right + 600) {
          swapImage(img);
        }
      });
    }
  }

  function insertProgressBar(wrapper) {
    if (wrapper.dataset.progressBarInserted) return;
    wrapper.dataset.progressBarInserted = 'true';

    var track = document.createElement('div');
    track.className = 'instafeed-carousel-bar';
    track.setAttribute('data-scroll-progress-track', '');

    var fill = document.createElement('div');
    fill.className = 'instafeed-carousel-bar-fill';
    fill.setAttribute('data-scroll-progress-fill', '');

    track.appendChild(fill);
    wrapper.insertAdjacentElement('afterend', track);
  }

  // The feed is configured as the app's own "slider" layout, whose touch
  // swipe detector calls InstafeedAPI.sliderMove() and writes a transform
  // onto the wrapper mid-gesture -- fighting the native overflow scroll on
  // iOS and freezing it. Its detector skips any touch whose direct target
  // carries data-swipe-ignore="true", so tag everything in the carousel.
  function ignoreAppSwipe(wrapper) {
    wrapper.setAttribute('data-swipe-ignore', 'true');
    wrapper.querySelectorAll('*:not([data-swipe-ignore])').forEach(function (el) {
      el.setAttribute('data-swipe-ignore', 'true');
    });
  }

  // Backstop for any touch the attribute misses: kill the app's swipe
  // events before they bubble up to its slider listeners.
  ['swiped', 'swiped-left', 'swiped-right'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (event.target && event.target.closest && event.target.closest('#insta-feed .instafeed-new-layout-wrapper')) {
        event.stopImmediatePropagation();
      }
    }, true);
  });

  // The image observer below is rooted on the wrapper, so it fires for the
  // first photos as soon as the page loads, even with the feed far down the
  // page (full-size Instagram files, ~1MB each). Hold image loading until the
  // feed itself is near the viewport.
  // Like the image observer, it lives on the wrapper so a wrapper swapped in
  // by the app gets its own.
  var feedNear = !('IntersectionObserver' in window);
  function watchFeed(wrapper) {
    if (wrapper.__instafeedFeedObserver) return;
    wrapper.__instafeedFeedObserver = new IntersectionObserver(
      function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        feedNear = true;
        wrapper.__instafeedFeedObserver.disconnect();
        loadImages(wrapper);
      },
      { rootMargin: '800px 0px' }
    );
    wrapper.__instafeedFeedObserver.observe(wrapper);
  }

  function setup() {
    var wrapper = document.querySelector('#insta-feed .instafeed-new-layout-wrapper');
    if (!wrapper) return;

    ignoreAppSwipe(wrapper);
    enforceStyles(wrapper);
    insertProgressBar(wrapper);
    if (feedNear) loadImages(wrapper);
    else watchFeed(wrapper);

    if (!wrapper.dataset.observerAttached) {
      wrapper.dataset.observerAttached = 'true';
      // The Instafeed app rewrites this element's inline style itself
      // (observed setting `gap` at runtime) which can intermittently clobber
      // the layout/scroll properties this carousel depends on. Re-assert
      // ours immediately whenever the app touches the style attribute again.
      var observer = new MutationObserver(function () {
        // Disconnect while we write, otherwise our own enforceStyles() call
        // would trigger this same callback again -- infinite loop.
        observer.disconnect();
        enforceStyles(wrapper);
        observer.observe(wrapper, { attributes: true, attributeFilter: ['style', 'class'] });
      });
      observer.observe(wrapper, { attributes: true, attributeFilter: ['style', 'class'] });
    }
  }

  setup();
  window.setInterval(setup, 800);
})();
